import { AuthTypeOption } from '../../../git-credentials/types';

import { columnHelper } from './helper';

export const authType = columnHelper.accessor(
  (row) => authTypeOptionToString(row.authorizationType),
  {
    id: 'authorizationType',
    header: 'Authorization Type',
  }
);

function authTypeOptionToString(authType: AuthTypeOption): string {
  switch (authType) {
    case AuthTypeOption.Basic:
      return 'Basic';
    case AuthTypeOption.Token:
      return 'Token';
    default:
      return 'Basic';
  }
}
